/*
  Pfad: /src/pages/stb/Stb_adv_analyse.js
  Funktion: Analyse einer Stellenanzeige via GPT (Konversion, Verbesserungsvorschläge)
*/

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Input } from '../../components/ui/input.jsx';
import { Button } from '../../components/ui/button.jsx';
import { Textarea } from '../../components/ui/textarea.jsx';
import { Card, CardContent } from '../../components/ui/card.jsx';



const Stb_adv_analyse = () => {
  const { id } = useParams();
  const [analyse, setAnalyse] = useState("");
  const [loading, setLoading] = useState(false);

  const starteAnalyse = async () => {
    setLoading(true);
    try {
      const res = await axios.post(`/api/gpt/analyse-anzeige/${id}`);
      setAnalyse(res.data.analyse);
    } catch (err) {
      console.error("Fehler bei Analyse:", err);
      alert("Fehler bei der GPT-Analyse.");
    }
    setLoading(false);
  };

  useEffect(() => {
    starteAnalyse();
  }, [id]);

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-6">Analyse der Stellenanzeige</h1>

      <Card className="shadow-lg">
        <CardContent className="p-6">
          {loading ? (
            <p className="text-blue-500">GPT denkt gerade nach...</p>
          ) : (
            <pre className="whitespace-pre-wrap text-gray-800">{analyse}</pre>
          )}
        </CardContent>
      </Card>

      <div className="mt-6 text-center">
        <Button onClick={starteAnalyse} variant="outline">Analyse neu starten</Button>
      </div>
    </div>
  );
};

export default Stb_adv_analyse;
